import {Component, h} from 'preact';
import invoke from 'lodash.invoke';
import PickList from '@components/common/PickList';
import Modal from '@components/common/Modal';
import AddPaymentForm from './AddPaymentForm';
import WalletItem from './WalletItem';
import Icon from '@components/common/Icon';

function setAddress( addressBook ) {
    return item => {
        if ( item && item.addressId ) {
            item.address = addressBook.find( a => a.id === item.addressId );
        }
        return item;
    }
}

const HOVER_CLASSES = 'border border-transparent border-solid t-border-color t-duration-short hover:border-sky-blue cursor-pointer';
const ITEMS_CLASSES = 'mt-4 rounded bg-near-white';

class AddressBook extends Component {

    static defaultProps = {
        itemIdProp: 'id',
        groupId: 'walletPickList',
        paymentMethods: [],
        defaultPaymentMethod: null,
        addressBook: [],
        allowAddItem: false,
        onPaymentChange: () => {
        },
        onPaymentAdded: () => {
        },
        onAddressAdded: () => {
        }
    };

    render( props ) {
        // map addressBook to paymentItem
        const setAddressProp = setAddress( props.addressBook );
        const paymentMethods = props.paymentMethods.map( setAddressProp );
        const defaultPaymentMethod = setAddressProp( props.defaultPaymentMethod );

        const isEmpty = !paymentMethods || !paymentMethods.length;

        return (
            <PickList
                itemType="payment method"
                itemIdProp={props.itemIdProp}
                groupId={props.groupId}
                list={paymentMethods}
                searchPlaceholder="Filter by name, vendor, or last 4 # on card"
                defaultSelection={defaultPaymentMethod}
                allowAddItem={props.allowAddItem}
                onItemChange={props.onPaymentChange}
                onItemAdded={props.onPaymentAdded}>
                {pickListProps => (
                    <div className={this.props.className}>
                        <div className="flex items-center w-full justify-between">
                            <h2 className="text-lg font-normal">Payment method</h2>
                            <PickList.EditAction/>
                        </div>
                        {isEmpty
                            ? <p className="mt-2 flex items-center">
                                <Icon.ui name="report-problem-triangle" className="text-lg mr-2"/>
                                No payment methods available
                            </p>
                            : <div>
                                <PickList.Selection
                                    className={ITEMS_CLASSES}
                                    interactionClassName={HOVER_CLASSES}
                                    itemRenderer={WalletItem}/>
                                <PickList.List
                                    queryProps={['lastFour', 'issuer', 'cardholder', 'meta']}
                                    itemRenderer={WalletItem}/>
                            </div>
                        }
                        <Modal
                            title="Add a new credit card"
                            id="addItemDialog"
                            size="sm"
                            isOpen={pickListProps.isAddingItem}
                            onClose={pickListProps.actions.toggleAddItem}>
                            <AddPaymentForm
                                addressBook={this.props.addressBook}
                                onCancel={pickListProps.actions.toggleAddItem}
                                onAddressAdded={payload => invoke( props, 'onAddressAdded', payload )}
                                onPaymentAdded={payload => {
                                    pickListProps.actions.handleItemAdded( payload );
                                    pickListProps.actions.toggleAddItem();
                                }}/>
                        </Modal>
                    </div>
                )}
            </PickList>
        );
    }
}

export default AddressBook;